import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "../tokens";
import { Icon, type IconName } from "./Icon";

/**
 * Boton de icono cuadrado, estilo "ghost". Debe llevar siempre un
 * aria-label: los iconos sin texto siguen siendo accesibles gracias a
 * la etiqueta. Replica el IconButton del proyecto de referencia, con
 * dimensiones compactas para encajar en la barra superior de 36 px.
 */
export interface IconButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  "aria-label": string;
  size?: "sm" | "md";
  iconSize?: number;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton({ icon, size = "md", iconSize, className, ...rest }, ref) {
    const dim = size === "sm" ? "h-6 w-6" : "h-7 w-7";
    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          "inline-flex items-center justify-center rounded text-[var(--color-on-surface-variant)] transition-colors hover:bg-[var(--color-surface-variant)] hover:text-[var(--color-on-surface)] focus:outline-none disabled:opacity-40 disabled:pointer-events-none",
          dim,
          className,
        )}
        {...rest}
      >
        <Icon name={icon} size={iconSize ?? (size === "sm" ? 14 : 16)} />
      </button>
    );
  },
);
